<template>
    <div class="main">
        <div class="dashboard-mod-wrap">
            <component
                ref="tabContent"
                :is="activeComId"
                @backToDashboard="backToDashboard"
                @accessLab="accessLab"
            ></component>
        </div>
    </div>
</template>

<script>
import dashboard from '@/components/dashboard.vue';
import reolinkLab from '@/components/reolinkLab.vue';
import lab from '@/api/lab.js';

export default {

    components: {

        dashboard,
        reolinkLab

    },

    data () {

        return {

            activeComId: 'dashboard'

        };

    },

    async created () {

        let labData = await lab.getLabInfo();
        this.$store.commit( 'LAB', labData );

    },

    methods: {

        accessLab () {

            this.activeComId = 'reolinkLab';

        },

        backToDashboard () {

            this.activeComId = 'dashboard';

        }
    }

};
</script>

<style type="text/css" lang="less">

    .dashboard-mod-wrap {
        padding: .6rem 0;
        @media @pc {
            background-color: #F3F4F9;
        }
        @media @mobile {
            padding: 0;
        }
        .dashboard-mod{
            max-width: 1200px;
            margin: 0 auto;
            border-radius: .2rem;
            background-color: #fff;
            padding: .6rem 0.6rem;
            box-sizing: border-box;
            min-height: 672px;
            @media @mobile {
                padding: .6rem 0 0.8rem;
                border-radius: 0;
                min-height: auto;
                & > * {
                    padding: 0 15px;
                }
            }
        }
    }

</style>



// WEBPACK FOOTER //
// src/view/dashboard/index.vue